import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { toggleDocumentAttribute } from 'src/app/utils/layout';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ThemeModeService {
  private isBrowser: boolean;
  private themePreference: MediaQueryList | null = null;

  private isDarkModeSubject = new BehaviorSubject<boolean>(false);
  isDarkMode$ = this.isDarkModeSubject.asObservable();

  private storageThemeKey = 'guestgenie-theme';
  private foundTheme: string | null = null;
  private themeAttributeKey = 'data-bs-theme';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      // Access browser-specific APIs safely
      this.themePreference = window.matchMedia('(prefers-color-scheme: dark)');
      this.foundTheme = localStorage.getItem(this.storageThemeKey);

      this.themePreference.addEventListener('change', () => {
        // We don't automatically change theme based on system preference anymore
        // Only change if no theme was previously set
        if (!this.foundTheme) {
          this.setLight();
        }
      });

      this.checkSwitch();
    }
  }

  private checkSwitch(): void {
    if (!this.isBrowser) return; // Skip logic if not in the browser

    if (this.foundTheme) {
      this.foundTheme === 'dark' ? this.setDark() : this.setLight();
    } else {
      // Default to light theme instead of system preference
      this.setLight();
    }
  }

  setLight(): void {
    if (this.isBrowser) {
      toggleDocumentAttribute(this.themeAttributeKey, 'light');
      localStorage.setItem(this.storageThemeKey, 'light');
      this.isDarkModeSubject.next(false);
    }
  }

  setDark(): void {
    if (this.isBrowser) {
      toggleDocumentAttribute(this.themeAttributeKey, 'dark');
      localStorage.setItem(this.storageThemeKey, 'dark');
      this.isDarkModeSubject.next(true);
    }
  }

  toggleTheme(): void {
    if (this.isDarkModeSubject.value) {
      this.setLight();
    } else {
      this.setDark();
    }
  }
}
